/* Whys Books · offer ladder (product page), cart drawer toggles, discount code, sticky ATC, geo currency. No app. */
(function () {
  'use strict';

  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function drawer() { return document.querySelector('cart-drawer'); }
  function rerender(json) {
    var d = drawer();
    if (d && d.classList.contains('is-empty')) d.classList.remove('is-empty');
    if (d && json && json.sections) { d.renderContents(json); }
    else if (json && json.status) { /* error */ }
    else { fetchDrawer(); }
  }
  function fetchDrawer() {
    return fetch(root() + '?sections=' + SECTIONS, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) { var d = drawer(); if (d) { d.classList.remove('is-empty'); d.renderContents({ sections: sections }); } });
  }
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function cartAdd(items) {
    return postJSON((window.routes && routes.cart_add_url) || '/cart/add.js', { items: items, sections: SECTIONS, sections_url: window.location.pathname });
  }
  function cartUpdate(body) {
    body.sections = SECTIONS; body.sections_url = window.location.pathname;
    return postJSON((window.routes && routes.cart_update_url) || '/cart/update.js', body);
  }
  function busy(el, on) { if (!el) return; el.disabled = !!on; el.classList.toggle('is-busy', !!on); el.setAttribute('aria-busy', on ? 'true' : 'false'); }

  /* 1. Offer ladder on the product page (native — 1 / 3 / 5 books + Field Lab add-ons) */
  var OFFER = null; /* { root, cfg, tier, pickTarget } */
  function money(cents) {
    var f = (OFFER && OFFER.cfg.moneyFormat) || '${{amount}}';
    var n = cents / 100;
    function grp(x, sep) { return x.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    var out = f;
    if (/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/.test(f)) out = f.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, grp(String(Math.round(n)), '.'));
    else if (/\{\{\s*amount_with_comma_separator\s*\}\}/.test(f)) out = f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, grp(n.toFixed(2).split('.')[0], '.') + ',' + n.toFixed(2).split('.')[1]);
    else if (/\{\{\s*amount_no_decimals\s*\}\}/.test(f)) out = f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, grp(String(Math.round(n)), ','));
    else if (/\{\{\s*amount_with_apostrophe_separator\s*\}\}/.test(f)) out = f.replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, grp(n.toFixed(2).split('.')[0], "'") + '.' + n.toFixed(2).split('.')[1]);
    else out = f.replace(/\{\{\s*amount\s*\}\}/, grp(n.toFixed(2).split('.')[0], ',') + '.' + n.toFixed(2).split('.')[1]);
    return out.replace(/<[^>]+>/g, '');
  }
  function offerTier() { return OFFER ? OFFER.tier : 0; }
  function activeTierEl() { return OFFER && OFFER.root.querySelector('[data-wb-tier="' + OFFER.tier + '"]'); }
  function offerSlots() { var t = activeTierEl(); return t ? [].slice.call(t.querySelectorAll('[data-wb-slot]')) : []; }
  function offerAddons() { return OFFER ? [].slice.call(OFFER.root.querySelectorAll('[data-wb-addon] input:checked')).map(function (i) { return i.closest('[data-wb-addon]'); }) : []; }
  function offerTotal() {
    if (!OFFER) return 0;
    var c = OFFER.cfg, t = OFFER.tier;
    var total = t === 1 ? c.unit : t === 3 ? c.trio : c.set.price;
    offerAddons().forEach(function (a) { total += parseInt(t === 5 ? a.getAttribute('data-disc') : a.getAttribute('data-price'), 10) || 0; });
    return total;
  }
  function offerItems() {
    if (!OFFER) return null;
    var t = OFFER.tier, items = [], counts = {};
    if (t === 5) { items.push({ id: OFFER.cfg.set.id, quantity: 1 }); }
    else {
      var missing = offerSlots().filter(function (s) { return !s.getAttribute('data-variant'); });
      if (missing.length) { return { missing: missing }; }
      offerSlots().forEach(function (s) { var id = s.getAttribute('data-variant'); counts[id] = (counts[id] || 0) + 1; });
      Object.keys(counts).forEach(function (id) { items.push({ id: parseInt(id, 10), quantity: counts[id] }); });
    }
    offerAddons().forEach(function (a) { items.push({ id: parseInt(a.getAttribute('data-variant'), 10), quantity: 1 }); });
    return { items: items };
  }
  function offerRefresh() {
    if (!OFFER) return;
    var total = money(offerTotal());
    document.querySelectorAll('[data-wb-atc-total]').forEach(function (el) { el.textContent = total; });
    document.querySelectorAll('[data-wb-sticky-price]').forEach(function (el) { el.textContent = total; });
    var addons = OFFER.root.querySelector('[data-wb-addons]');
    if (addons) {
      addons.classList.toggle('is-deal', OFFER.tier === 5);
      var note = addons.querySelector('[data-wb-addons-note]');
      if (note) note.textContent = OFFER.tier === 5 ? OFFER.cfg.labPct + '% off each set, applied in the cart' : 'Save ' + OFFER.cfg.labPct + '% on each set when you take all 5 books';
    }
  }
  function setTier(n) {
    if (!OFFER) return;
    OFFER.tier = n;
    OFFER.root.querySelectorAll('[data-wb-tier]').forEach(function (x) {
      var on = parseInt(x.getAttribute('data-wb-tier'), 10) === n;
      x.classList.toggle('is-active', on); x.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var page = OFFER.root.closest('.wp-pdp') || document;
    page.classList.toggle('wp-tier-multi', n !== 1);
    offerRefresh();
  }
  function fillSlot(slot, row) {
    slot.setAttribute('data-variant', row.getAttribute('data-variant'));
    slot.classList.add('is-filled', 'is-just-filled');
    setTimeout(function () { slot.classList.remove('is-just-filled'); }, 600);
    var label = slot.querySelector('.wp-slot__label'); var labelHtml = label ? label.innerHTML : '';
    slot.innerHTML = '<span class="wp-slot__arrow" aria-hidden="true"></span>' +
      '<img class="wp-slot__thumb" src="' + row.getAttribute('data-img') + '" width="44" height="60" alt="" loading="lazy">' +
      '<span class="wp-slot__text">' + (labelHtml ? '<span class="wp-slot__label">' + labelHtml + '</span>' : '') + '<span class="wp-slot__name">' + row.getAttribute('data-title') + '</span></span>' +
      '<button type="button" class="wp-slot__change" data-wb-choose>Change</button>';
    offerRefresh();
  }
  function openPick(slot) {
    var d = OFFER.root.querySelector('[data-wb-pick]'); if (!d) return;
    OFFER.pickTarget = slot;
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); } else { d.setAttribute('open', ''); }
  }
  function closePick() { var d = OFFER && OFFER.root.querySelector('[data-wb-pick]'); if (d) { if (d.open && d.close) d.close(); else d.removeAttribute('open'); } }
  function initOffer() {
    var root = document.querySelector('[data-wb-offer]'); if (!root) return;
    var cfgEl = root.querySelector('[data-wb-offer-config]'); var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {}
    OFFER = { root: root, cfg: cfg, tier: 3, pickTarget: null };
    setTier(parseInt(root.getAttribute('data-default-tier'), 10) || 3);
    root.addEventListener('click', function (e) {
      var choose = e.target.closest('[data-wb-choose]');
      if (choose) { e.preventDefault(); e.stopPropagation(); var slot = choose.closest('[data-wb-slot]'); var tier = choose.closest('[data-wb-tier]'); if (tier) setTier(parseInt(tier.getAttribute('data-wb-tier'), 10)); openPick(slot); return; }
      var pickRow = e.target.closest('[data-wb-pick-row]');
      if (pickRow && e.target.closest('[data-wb-pick-choose], [data-wb-pick-row]')) { e.preventDefault(); if (OFFER.pickTarget) fillSlot(OFFER.pickTarget, pickRow); closePick(); return; }
      if (e.target.closest('[data-wb-pick-close]')) { e.preventDefault(); closePick(); return; }
      var dlg = e.target.closest('[data-wb-pick]');
      if (dlg && e.target === dlg) { closePick(); return; }
      if (e.target.closest('[data-wb-addon]')) { var tierOfAddon = OFFER.tier; setTimeout(offerRefresh, 0); return; }
      var tier = e.target.closest('[data-wb-tier]');
      if (tier) { setTier(parseInt(tier.getAttribute('data-wb-tier'), 10)); }
    });
    root.addEventListener('keydown', function (e) {
      var tier = e.target.closest && e.target.closest('[data-wb-tier]');
      if (tier && (e.key === 'Enter' || e.key === ' ') && e.target === tier) { e.preventDefault(); setTier(parseInt(tier.getAttribute('data-wb-tier'), 10)); }
    });
    root.addEventListener('change', function (e) { if (e.target.closest('[data-wb-addon]')) offerRefresh(); });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!OFFER) return; /* no offer ladder on this page → let Dawn handle it */
    e.preventDefault(); e.stopImmediatePropagation();
    var built = offerItems();
    if (!built || built.missing) {
      if (built && built.missing.length) {
        built.missing.forEach(function (s) { s.classList.add('is-missing'); setTimeout(function () { s.classList.remove('is-missing'); }, 1200); });
        built.missing[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
        openPick(built.missing[0]);
      }
      return;
    }
    var submit = form.querySelector('[type=submit]'); busy(submit, true);
    cartAdd(built.items).then(function (json) {
      busy(submit, false);
      if (json.status) { var err = form.querySelector('.product-form__error-message'); if (err) { err.textContent = json.description || json.message; var w = err.closest('.product-form__error-message-wrapper'); if (w) w.hidden = false; } return; }
      rerender(json);
      if (window.publish && window.PUB_SUB_EVENTS) { try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: json }); } catch (err) {} }
    }).catch(function () { busy(submit, false); });
  }, true);

  /* 2. Drawer actions: upsell toggles, upgrade, discount code, copy code */
  function applyDiscount(code, msgEl, btn) {
    code = (code || '').trim().toUpperCase(); if (!code) return;
    busy(btn, true);
    cartUpdate({ discount: code }).then(function (json) {
      var applied = (json.discount_codes || []).some(function (d) { return d.code.toUpperCase() === code && d.applicable; });
      if (!applied) { busy(btn, false); if (msgEl) { msgEl.textContent = 'That code isn’t valid for this cart.'; msgEl.hidden = false; } return; }
      try { sessionStorage.setItem('wb_code', code); } catch (e) {}
      rerender(json);
    }).catch(function () { busy(btn, false); });
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-wb-toggle]');
    if (sw) {
      e.preventDefault(); busy(sw, true);
      var on = sw.classList.contains('is-on');
      var p;
      if (on) {
        var upd = {}; upd[sw.getAttribute('data-wb-toggle')] = 0;
        p = cartUpdate({ updates: upd });
      } else {
        p = cartAdd([{ id: parseInt(sw.getAttribute('data-wb-toggle'), 10), quantity: 1 }]);
      }
      p.then(function (json) { if (json.status) { busy(sw, false); return; } rerender(json); }).catch(function () { busy(sw, false); });
      return;
    }
    var up = e.target.closest('[data-wb-upgrade]');
    if (up) {
      e.preventDefault(); busy(up, true);
      var updates = {};
      (up.getAttribute('data-wb-remove') || '').split(',').forEach(function (id) { if (id) updates[id] = 0; });
      postJSON((window.routes && routes.cart_update_url) || '/cart/update.js', { updates: updates })
        .then(function () { return cartAdd([{ id: parseInt(up.getAttribute('data-wb-upgrade'), 10), quantity: 1 }]); })
        .then(function (json) { if (json.status) { busy(up, false); return; } rerender(json); })
        .catch(function () { busy(up, false); });
      return;
    }
    var ap = e.target.closest('[data-wb-apply]');
    if (ap) { e.preventDefault(); var wrap = ap.closest('[data-wb-discount]'); applyDiscount(wrap.querySelector('input').value, wrap.querySelector('[data-wb-msg]'), ap); return; }

    var c = e.target.closest('[data-wb-copy]');
    if (c) {
      e.preventDefault();
      var code = c.getAttribute('data-wb-copy');
      var done = function () { c.classList.add('is-copied'); var l = c.querySelector('[data-wb-copy-label]'); if (l) l.textContent = 'Copied · applies at checkout'; };
      try { sessionStorage.setItem('wb_code', code); } catch (e2) {}
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-wb-discount] input')) {
      e.preventDefault(); var wrap = e.target.closest('[data-wb-discount]');
      applyDiscount(e.target.value, wrap.querySelector('[data-wb-msg]'), wrap.querySelector('[data-wb-apply]'));
    }
  });

  /* 3. Sticky add-to-cart (product page, mobile) */
  function initSticky() {
    var bar = document.querySelector('[data-wb-sticky]');
    var form = document.querySelector('product-form form, form[data-type="add-to-cart-form"]');
    if (!bar || !form) return;
    var submit = form.querySelector('[type="submit"]');
    var io = new IntersectionObserver(function (en) { bar.classList.toggle('is-visible', !en[0].isIntersecting); }, { threshold: 0 });
    if (submit) io.observe(submit);
    var btn = bar.querySelector('[data-wb-sticky-add]');
    if (btn) btn.addEventListener('click', function () { if (submit) submit.click(); });
  }

  /* 4. Auto-localise: switch country + currency to where the visitor really is, once per session, unless they chose a country themselves */
  function autoLocalise() {
    var MANUAL = 'wb_locale_manual', DONE = 'wb_locale_checked';
    try { if (localStorage.getItem(MANUAL) || sessionStorage.getItem(DONE)) return; } catch (e) { return; }
    if (!window.Shopify || !Shopify.country) return;
    fetch(root() + 'browsing_context_suggestions.json?country[enabled]=true&currency[enabled]=true', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        try { sessionStorage.setItem(DONE, '1'); } catch (e) {}
        if (!data || !data.detected_values || !data.detected_values.country) return;
        var detected = data.detected_values.country.handle;
        if (!detected || detected === Shopify.country) return;
        var f = document.createElement('form'); f.method = 'post'; f.action = root() + 'localization'; f.hidden = true;
        var add = function (n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i); };
        add('form_type', 'localization'); add('utf8', '✓'); add('_method', 'put'); add('country_code', detected); add('return_to', location.pathname + location.search + location.hash);
        document.body.appendChild(f); f.submit();
      }).catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches('form[action*="/localization"]') && !e.target.hidden) { try { localStorage.setItem('wb_locale_manual', '1'); } catch (err) {} }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    initOffer(); initSticky(); autoLocalise();
  });
})();
